import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';

const PlantSensor = (props) => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Humidity (0: hydrated - 1024: dry)</TableCell>
        <TableCell>Name</TableCell>
        <TableCell numeric>Timestamp</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {
        props.rows.map(row => {
          return (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.humidity}
              </TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell numeric>{moment.unix(row.timestamp).format("h:mm:ss a, dddd, MMMM Do YYYY")}</TableCell>
            </TableRow>
          );
        })
      }
    </TableBody>
  </Table>
);

export default PlantSensor;
